"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _modal = _interopRequireDefault(require("@ux/modal"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _rtbCardsSection = _interopRequireDefault(require("../../page-body/commerce/rtb-cards-section"));
var _swpFacadeCard = _interopRequireDefault(require("../../page-body/commerce/rtb-cards-section/common/swp-facade-card"));
function RecoreModal({
  cards,
  modalProps
}) {
  const StyledModal = /*#__PURE__*/(0, _react2.styled)(_modal.default)({
    name: "StyledModal",
    class: "pl-ss155le"
  });
  const CartContainer = /*#__PURE__*/(0, _react2.styled)("div")({
    name: "CartContainer",
    class: "pl-cqvl26k"
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "recore-modal"
  }, /*#__PURE__*/_react.default.createElement(StyledModal, modalProps, /*#__PURE__*/_react.default.createElement(_patternLibraryUtils.ModalPatch, null), /*#__PURE__*/_react.default.createElement(_rtbCardsSection.default, null, cards.map((card, index) => /*#__PURE__*/_react.default.createElement(_swpFacadeCard.default, (0, _extends2.default)({
    key: index
  }, card))))), /*#__PURE__*/_react.default.createElement(CartContainer, null, " ", " "));
}
var _default = exports.default = RecoreModal;
RecoreModal.propTypes = {
  cards: _propTypes.default.array,
  ..._modal.default.propTypes
};